<template>
  <v-dialog :value="dialogProp.show" persistent max-width="900">
    <v-card class="elevation-12">
      <v-toolbar :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t('Редактирование данных организации') }}
        </v-toolbar-title>
      </v-toolbar>
      <general-error v-if="!!generalError" />
      <v-card-text class="pt-3">
        <organization-info
            ref="organization"
            :participant-types="PARTICIPANT_TYPE_ENUM"
            :organization-info="organization"
            readonly-participant-types
            @keydown.native.enter="focusOnBtn('saveBtn')"
            @change="mergeFieldsAction" />
      </v-card-text>
      <v-progress-linear :active="isLoading" color="loader" indeterminate />
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelBtn"
            v-test="{ btn: 'save' }"
            color="primary"
            @click.stop="cancel">
          {{ $t('Отмена') }}
        </v-btn>
        <v-btn
            id="saveBtn"
            ref="saveBtn"
            v-test="{ btn: 'save' }"
            color="primary"
            :disabled="isLoading"
            @click.stop="updateOrganization">
          {{ $t('Сохранить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import Vue from 'vue'
  import OrganizationInfo from '@/components/reused/organization/OrganizationInfo.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  // import { PARTICIPANT_TYPES } from '@/constants/business.js'
  import { PARTICIPANT_TYPE_ENUM } from '@/constants/enums'
  import { mapActions, mapState } from 'vuex'
  import { ORGANIZATION_MANAGEMENT } from '@/constants/store.js'

  export default {
    components: {
      OrganizationInfo,
      GeneralError
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            organizationId: null,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        PARTICIPANT_TYPE_ENUM,
        isLoading: false
      }
    },
    computed: {
      ...mapState(ORGANIZATION_MANAGEMENT.NAMESPACE, {
        organization: state => (state[ORGANIZATION_MANAGEMENT.STATE.ORGANIZATION_EDIT_INFO] || { }),
        organizationChanged: state => (state[ORGANIZATION_MANAGEMENT.STATE.ORGANIZATION_CHANGED] || false)
      })
    },
    created () {
      this.clearStore().then(this.getOrganizationInfo)
    },
    beforeDestroy () {
      this.clearStore()
    },
    methods: {
      ...mapActions(ORGANIZATION_MANAGEMENT.NAMESPACE, {
        mergeFieldsAction: ORGANIZATION_MANAGEMENT.ACTIONS.MERGE_FIELDS,
        getOrganizationEditInfoAction: ORGANIZATION_MANAGEMENT.ACTIONS.GET_ORGANIZATION_EDIT_INFO,
        updateOrganizationAction: ORGANIZATION_MANAGEMENT.ACTIONS.UPDATE_ORGANIZATION,
        clearOrganizationEditInfoAction: ORGANIZATION_MANAGEMENT.ACTIONS.CLEAR_ORGANIZATION_EDIT_INFO
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearOrganizationEditInfoAction()
          ])
      },
      getOrganizationInfo: async function () {
        try {
          this.isLoading = true

          await this.getOrganizationEditInfoAction({
            organizationId: this.dialogProp.organizationId
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      updateOrganization: async function () {
        try {
          const isValidated = await this.$refs.organization.validate()
          if (!isValidated) {
            throw new Vue.errorsTypes.ValidationError()
          }
          if (this.organizationChanged) {
            this.isLoading = true
            await this.updateOrganizationAction(this.organization)
            this.isLoading = false
            if (this.dialogProp.callback) {
              this.dialogProp.callback()
            }
          }

          this.cancel()
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
